import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  es: {
    translation: {
      'common.login': 'Iniciar Sesión',
      'common.logout': 'Cerrar Sesión',
      'common.email': 'Correo Electrónico',
      'common.password': 'Contraseña',
      'common.name': 'Nombre',
      'common.surname': 'Apellidos',
      'common.save': 'Guardar',
      'common.cancel': 'Cancelar',
      'common.loading': 'Cargando...',
      'common.error': 'Error',
      'common.success': 'Éxito',
      'common.search': 'Buscar',
      'common.filter': 'Filtrar',
      'common.download': 'Descargar',
      'common.sign': 'Firmar',
      'common.signHere': 'Firme aquí',
      'common.clear': 'Limpiar',
      'common.submit': 'Enviar',
      'common.back': 'Volver',
      'common.viewDetails': 'Ver Detalles',
      'dashboard.title': 'Panel de Prestamista',
      'dashboard.totalCapital': 'Capital Total Invertido',
      'dashboard.interestToday': 'Intereses Hoy',
      'dashboard.interestMonth': 'Intereses Este Mes',
      'dashboard.estimatedReturn': 'Retorno Estimado Total',
      'dashboard.activeLoans': 'Préstamos Activos',
      'dashboard.pendingSignatures': 'Firmas Pendientes',
      'dashboard.yourMoneyWorking': 'Tu dinero está trabajando para ti',
      'dashboard.investMore': 'Quiero invertir más',
      'dashboard.interestEvolution': 'Evolución de Intereses',
      'dashboard.simulator': 'Simulador de Inversión',
      'dashboard.simulatorDesc': 'Si inviertes',
      'dashboard.wouldBe': 'tu retorno sería',
      'dashboard.days': 'días',
      'dashboard.daysRemaining': 'días restantes',
      'loans.title': 'Mis Préstamos',
      'loans.loanId': 'ID Préstamo',
      'loans.capital': 'Capital',
      'loans.interestRate': 'Tipo de Interés',
      'loans.startDate': 'Fecha Inicio',
      'loans.endDate': 'Fecha Vencimiento',
      'loans.status': 'Estado',
      'loans.interestGenerated': 'Intereses Generados',
      'loans.daysRemaining': 'Días Restantes',
      'loans.active': 'Activo',
      'loans.pending_signature': 'Pendiente de Firma',
      'loans.matured': 'Vencido',
      'loans.cancelled': 'Cancelado',
      'contracts.title': 'Contratos',
      'loanRequest.pendingRequests': 'Solicitudes Pendientes',
      'loanRequest.rejectedRequests': 'Solicitudes Rechazadas',
      'loanRequest.noPendingRequests': 'No hay solicitudes pendientes',
      'loanRequest.canRequestFromDashboard': 'Puedes solicitar un nuevo préstamo desde el Dashboard',

      'contracts.pendingSignature': 'Tienes un contrato pendiente de firma!',
      'contracts.clickToSign': 'Haz clic aqui para ir a firmar tu contrato',
      'contracts.signed': 'Firmados',
      'contracts.contractId': 'ID Contrato',
      'contracts.loanDetails': 'Detalles del Préstamo',
      'contracts.signContract': 'Firmar Contrato',
      'contracts.downloadContract': 'Descargar Contrato',
      'contracts.signatures': 'Firmas',
      'contracts.lender': 'Prestamista',
      'contracts.company': 'Empresa',
      'contracts.signedAt': 'Firmado el',
      'contracts.ipAddress': 'Dirección IP',
      'admin.dashboard': 'Panel de Administración',
      'admin.lenders': 'Prestamistas',
      'admin.loans': 'Préstamos',
      'admin.createLender': 'Crear Prestamista',
      'admin.createLoan': 'Crear Préstamo',
      'admin.generateContract': 'Generar Contrato',
      'admin.totalCapital': 'Capital Total Gestionado',
      'admin.activeLoans': 'Préstamos Activos',
      'admin.totalLenders': 'Total Prestamistas',
      'admin.newLoansMonth': 'Nuevos Préstamos (Mes)',
      'admin.interestAccrued': 'Intereses Acumulados',
      'admin.lenderName': 'Nombre del Prestamista',
      'profile.lender': 'Prestamista',
      'sidebar.logout': 'Cerrar Sesión',
      'contracts.noContracts': 'No hay contratos disponibles',
      'contracts.contractsWillAppear': 'Los contratos aparecerán cuando se generen',


      'admin.lenderEmail': 'Email del Prestamista',
      'admin.documentType': 'Tipo de Documento',
      'admin.documentNumber': 'Número de Documento',
      'admin.address': 'Dirección',
      'admin.phone': 'Teléfono',
      
      // Additional translations
      'profile.title': 'Mi Perfil',
      'profile.personalInfo': 'Información Personal',
      'profile.changePassword': 'Cambiar Contraseña',
      'profile.currentPassword': 'Contraseña Actual',
      'profile.newPassword': 'Nueva Contraseña',
      'profile.confirmPassword': 'Confirmar Nueva Contraseña',
      'profile.minChars': 'Mínimo 6 caracteres',
      'profile.passwordUpdated': 'Contraseña actualizada exitosamente',
      'profile.passwordsDontMatch': 'Las contraseñas no coinciden',
      'profile.userName': 'Nombre',
      'profile.userEmail': 'Email',
      'profile.userType': 'Tipo de usuario',
      'profile.userLanguage': 'Idioma',
      'profile.administrator': 'Administrador',
      'profile.lender': 'Prestamista',
      
      'forgotPassword.title': 'Recuperar Contraseña',

      // Complete Profile
      'completeProfile.welcome': 'Bienvenido',
      'completeProfile.subtitle': 'Completa tu perfil para empezar a invertir',
      'completeProfile.infoText': 'Para cumplir con la normativa legal, necesitamos tus datos personales y fiscales antes de poder procesar tu primera solicitud de prestamo.',
      'completeProfile.fillRequired': 'Por favor, completa todos los campos obligatorios (incluido IBAN)',
      'completeProfile.saved': 'Perfil completado correctamente',
      'completeProfile.ibanNote': 'Para recibir transferencias de los intereses generados',
      'completeProfile.saveButton': 'Guardar y Continuar',
      'completeProfile.requiredFields': 'Campos obligatorios',

      'forgotPassword.description': 'Ingresa tu email y te enviaremos una contraseña temporal.',
      'forgotPassword.link': '¿Olvidaste tu contraseña?',
      'forgotPassword.success': 'Si el email existe, recibirás instrucciones.',
      'forgotPassword.error': 'Error al procesar',
      
      'investment.requestTitle': 'Solicitar Nueva Inversión',
      'investment.amount': 'Monto a Invertir (€)',
      'investment.notes': 'Notas adicionales (opcional)',
      'investment.notesPlaceholder': 'Preferencias de plazo, condiciones especiales, etc.',
      'investment.emailNote': 'Al enviar, recibiremos tu solicitud y nos pondremos en contacto contigo en breve.',
      'investment.sendRequest': 'Enviar Solicitud',
      'investment.sending': 'Enviando...',
      'investment.success': 'Solicitud enviada correctamente. Nos pondremos en contacto en breve.',
      
      'loanDetail.title': 'Detalle del Préstamo',
      'loanDetail.loanAt': 'Préstamo al',
      'loanDetail.annual': 'anual',
      'loanDetail.interestGenerated': 'Intereses Generados',
      'loanDetail.estimatedReturn': 'Retorno Total Estimado',
      'loanDetail.daysRemaining': 'Días Restantes',
      'loanDetail.dailyInterest': 'Interés Diario',
      'loanDetail.timeline': 'Línea de Tiempo del Préstamo',
      'loanDetail.completed': 'completado del plazo total',
      'loanDetail.projection': 'Proyección de Intereses Acumulados',
      'loanDetail.contractInfo': 'Información del Contrato',
      'loanDetail.viewContract': 'Ver Contrato',
      'loanDetail.earlyCancellation': 'Cancelación Anticipada',
      'loanDetail.cancellationWarning': 'Si necesitas cancelar este préstamo antes del vencimiento, ten en cuenta que se aplicará una penalización de 2.5% sobre el tipo de interés.',
      'loanDetail.requestCancellation': 'Solicitar Cancelación Anticipada',
      'loanDetail.cancellationConfirm': '¿Solicitar cancelación anticipada?',
      'loanDetail.penalty': 'Penalización: Tu tipo de interés se reducirá de',
      'loanDetail.to': 'a',
      'loanDetail.requestReceived': 'Solicitud recibida correctamente. Nos pondremos en contacto en breve.',
      
      'simulator.title': 'Simulador de Inversión',
      'simulator.ifYouInvest': 'Si inviertes',
      'simulator.additional': 'adicionales',
      'simulator.estimatedReturn': 'Retorno estimado:',
      'simulator.increase': 'Aumento de',
      'simulator.simulate': 'Simula cuánto ganarías invirtiendo:',
      'simulator.amount': 'Importe',
      'simulator.interestRate': 'Tipo de interés',
      'simulator.earningsDay': 'GANANCIAS POR DÍA',
      'simulator.earningsMonth': 'GANANCIAS POR MES',
      'simulator.earningsYear': 'GANANCIAS POR AÑO',
      'simulator.dailyGrowth': '¡Tu dinero crece cada día!',
      'simulator.monthlyIncome': 'Ingresos mensuales garantizados',
      'simulator.totalYield': 'Rendimiento total anual',
      'simulator.totalReturn': 'Retorno total a 12 meses',
      
      'buttons.investMore': 'Quiero Invertir Más',
      'buttons.viewAllLoans': 'Ver todos los préstamos',
      'buttons.createLender': 'Crear Prestamista',
      'buttons.createLoan': 'Crear Préstamo',
      'buttons.editLoan': 'Editar',
      'buttons.generateES': 'Generar ES',
      'buttons.generateCA': 'Generar CA',
      'buttons.personalizeContract': 'Personalizar Contrato',
      'buttons.exportCSV': 'Exportar CSV',
      'buttons.resetPassword': 'Reset',
      'buttons.edit': 'Editar',
      'buttons.save': 'Guardar',
      'buttons.saveChanges': 'Guardar Cambios',
      'buttons.saveDraft': 'Guardar Borrador',
      'buttons.generateAndSend': 'Generar Contrato y Enviar',
      'buttons.back': 'Volver',
      
      'status.active': 'Activo',
      'status.pending': 'Pendiente',
      'status.matured': 'Vencido',
      'status.cancelled': 'Cancelado',
      'status.contractGenerated': 'Contrato generado',
      
      'messages.lenderCreated': 'Prestamista creado exitosamente',
      'messages.loanCreated': 'Préstamo creado exitosamente',
      'messages.loanUpdated': 'Préstamo actualizado exitosamente',
      'messages.lenderUpdated': 'Prestamista actualizado exitosamente',
      'messages.passwordReset': 'Contraseña reseteada exitosamente',
      'messages.communicatePassword': 'Comunica esta contraseña al usuario.',
      'messages.csvExported': 'Reporte CSV descargado exitosamente',
      'messages.noDataToExport': 'No hay datos para exportar',
      'messages.contractGenerated': 'Contrato generado y emails enviados',
      'messages.signedSuccessfully': 'Contrato firmado exitosamente',
      'messages.pleaseSign': 'Por favor, firme en el recuadro',
      'messages.confirmDelete': '¿Está seguro?',
      'messages.error': 'Error',
      'messages.success': 'Éxito',
      
      'labels.name': 'Nombre',
      'labels.surname': 'Apellidos',
      'labels.email': 'Email',
      'labels.docType': 'Tipo de Documento',
      'labels.docNumber': 'Número de Documento',
      'labels.address': 'Dirección Completa',
      'labels.phone': 'Teléfono',
      'labels.country': 'País',
      'labels.iban': 'IBAN (Opcional)',
      'labels.language': 'Idioma Preferido',
      'labels.lender': 'Prestamista',
      'labels.capital': 'Capital (€)',
      'labels.interestRate': 'Tipo de Interés (%)',
      'labels.duration': 'Duración (meses)',
      'labels.startDate': 'Fecha de Inicio',
      'labels.actions': 'Acciones',
      'labels.fullName': 'Nombre Completo',
      'labels.document': 'Documento',
      
      'placeholders.searchLenders': 'Buscar por nombre, apellidos o email...',
      'placeholders.selectLender': 'Seleccionar...',
      'placeholders.amount': '10000',
      'placeholders.address': 'C/ Méndez Núñez, 8, 1º 2ª, 08003, Barcelona',
      'placeholders.phone': '+34 912 345 678',
      'placeholders.iban': 'ES91 2100 0418 4502 0005 1332',
      
      'titles.editLender': 'Editar Prestamista',
      'titles.createLender': 'Crear Nuevo Prestamista',
      'titles.editLoan': 'Editar Préstamo',
      'titles.createLoan': 'Crear Nuevo Préstamo',
      'titles.loanTerms': 'Términos del Préstamo (Editables)',
      'titles.summary': 'Resumen',
      'titles.welcome': 'Hola',
      'titles.dashboardSubtitle': 'Aquí está el resumen de tu gestión',
      'titles.activeLoans': 'Préstamos Activos',
      'titles.statusDistribution': 'Distribución por Estado',
      'titles.quickStats': 'Estadísticas Clave',
      'titles.recentActivity': 'Actividad Reciente',
      
      'stats.avgCapital': 'Capital Promedio/Préstamo',
      'stats.signRate': 'Tasa de Firma',
      'stats.newThisMonth': 'Nuevos Este Mes',
      'stats.totalManaged': 'Total en gestión activa',
      'stats.generatedToday': 'Generados hasta hoy',
      'stats.currentlyActive': 'En curso actualmente',
      'stats.registeredInvestors': 'Inversores registrados',
      'stats.daysRemaining': 'días restantes',
      'stats.at': 'al',
      
      // Waitlist & Invitations (ES)
      'waitlist.title': 'Solicita Acceso a Vivendius',
      'waitlist.subtitle': 'Únete al club de inversores exclusivo',
      'waitlist.nombre': 'Nombre Completo',
      'waitlist.email': 'Email',
      'waitlist.telefono': 'Teléfono',
      'waitlist.capitalDisponible': 'Capital Disponible',
      'waitlist.tipoInversion': 'Tipo de Inversión',
      'waitlist.shortTerm': 'Corto plazo (12 meses)',
      'waitlist.mediumTerm': 'Medio plazo (24 meses)',
      'waitlist.longTerm': 'Largo plazo (36 meses)',
      'waitlist.minAmount': 'Mínimo: {{amount}}€',
      'waitlist.invitationCode': 'Código de Invitación',
      'waitlist.notas': 'Notas adicionales (opcional)',
      'waitlist.submit': 'Enviar Solicitud',
      'waitlist.joinWaitlist': 'Unirme a la Lista de Espera',
      'waitlist.successTitle': '¡Solicitud Enviada!',
      'waitlist.successMessage': 'Revisaremos tu solicitud y nos pondremos en contacto pronto.',
      'waitlist.backToHome': 'Volver al inicio',

      'waitlist.success': '¡Solicitud enviada correctamente! Nos pondremos en contacto pronto.',
      'waitlist.exclusiveMessage': 'Inversiones exclusivas en propiedades tangibles en Barcelona. Compramos, rehabilitamos y vendemos con todas las garantías.',
      'waitlist.missionMessage': 'Con tu colaboración nos estás ayudando a crecer y ofrecer viviendas a precios accesibles para familias y parejas jóvenes que buscan libertad, calidad y precio accesible sin intermediarios.',
      'waitlist.exclusiveClub': 'Club Exclusivo por Invitación',
      'waitlist.limitedAccess': 'Acceso limitado a inversores de confianza',
      
      'invitations.title': 'Mis Invitaciones',
      'invitations.available': 'Invitaciones Disponibles',
      'invitations.used': 'Invitaciones Utilizadas',
      'invitations.generate': 'Generar Código de Invitación',
      'invitations.yourCode': 'Tu Código',
      'invitations.shareCode': 'Comparte este código con personas de confianza',
      'invitations.noInvitations': 'Has utilizado todas tus invitaciones',
      'invitations.usedBy': 'Utilizado por',
      'invitations.status': 'Estado',
      
      'admin.waitlist': 'Lista de Espera',
      'admin.waitlistPending': 'Pendientes de Aprobación',
      'admin.approveEntry': 'Aprobar',
      'admin.rejectEntry': 'Rechazar',
      'admin.waitlistName': 'Nombre',
      'waitlist.tagline': 'Investments Made Easy',
      'waitlist.waitingList': 'Lista de Espera',
      'waitlist.privateClub': 'Club Privado de Inversores Inmobiliarios',
      'waitlist.onlyInvitation': 'SOLO POR INVITACIÓN',
      'waitlist.restrictedAccess': 'Acceso Restringido',
      'waitlist.privateExclusiveClub': 'Club exclusivo privado. Solo se puede acceder con invitación',
      'waitlist.codeRequired': 'Código Requerido',
      'waitlist.alreadyHaveAccount': '¿Ya tienes cuenta? Inicia sesión',
      'waitlist.guaranteedFixed': 'Fijo Garantizado',
      'waitlist.barcelona': 'Barcelona',
      'waitlist.risks': 'Riesgos',



      'admin.waitlistCapital': 'Capital Disponible',
      'admin.waitlistType': 'Tipo Inversión',
      'admin.waitlistReferredBy': 'Referido por',
      
      // Error messages and alerts
      'errors.unknown': 'Error desconocido',
      
      // Invitations (ES)
      'invitations.myInvitations': 'Mis Invitaciones',
      'invitations.inviteTrusted': 'Invita personas de confianza al club Vivendius',
      'invitations.available': 'Disponibles',
      'invitations.generateNewCode': 'Generar Nuevo Código de Invitación',
      'invitations.codeOnceUse': 'Cada código se puede utilizar una vez. Compártelo solo con personas de confianza.',
      'invitations.generateCode': '+ Generar Código',
      'invitations.generating': 'Generando...',
      'invitations.codeGenerated': '¡Código generado!',
      'invitations.copy': 'Copiar',
      'invitations.noInvitationsLeft': 'Has utilizado todas tus invitaciones',
      'invitations.myCodes': 'Mis Códigos',
      'invitations.noCodesYet': 'Aún no has generado ningún código',
      'invitations.usedBy': 'Utilizado por',
      'invitations.active': 'Activo',
      'invitations.used': 'Utilizado',
      
      // Sidebar & Navigation
      'sidebar.projects': 'Proyectos',
      'sidebar.waitlist': 'Lista de Espera',
      'sidebar.loanRequests': 'Solicitudes Prestamos',
      'sidebar.pendingCancellations': 'Cancelaciones Pendientes',
      'sidebar.approvedCancellations': 'Cancelaciones Aprobadas',
      'sidebar.rateTiers': 'Baremos',
      'sidebar.profile': 'Perfil',
      'sidebar.dashboard': 'Dashboard',

      'errors.loading': 'Error al cargar',
      'errors.downloading': 'Error al descargar',
      'errors.saving': 'Error al guardar',
      'errors.creating': 'Error al crear',
      
      // Status labels
      'status.creating': 'Creando...',
      'status.saving': 'Guardando...',
      'status.loading': 'Cargando...',
      'status.all': 'Todos',
      
      // Modal titles
      'modal.createLender': '+ Crear Nuevo Prestamista',
      'modal.editLender': '✏️ Editar Prestamista',
      'modal.createLoan': '+ Crear Nuevo Préstamo',
      'modal.editLoan': '✏️ Editar Préstamo',
      
      // Button labels with icons
      'buttons.createLenderButton': '✓ Crear Prestamista',
      'buttons.createLoanButton': '✓ Crear',
      
      // Date formats
      'date.signedOn': 'Firmado el',
      'date.ip': 'IP',
      
      // Contract editing
      'contract.editTitle': 'Editar Contrato',
      'contract.loanTerms': 'Términos del Préstamo (Editables)',
      'contract.generating': 'Generando...',
      'contract.generateFinal': 'Generar Contrato Final',
      
      // Loan Requests
      'loanRequest.suggestedRate': 'Tipo de interés',
      'loanRequest.annual': 'anual',
      'loanRequest.requestDate': 'FECHA SOLICITUD',
      'loanRequest.notes': 'NOTAS',
      'loanRequest.statusTitle': 'Estado de la solicitud',
      'loanRequest.statusMessage': 'Tu solicitud de {amount}€ está siendo revisada por el equipo de Vivendius. Recibirás una notificación por email cuando sea aprobada y se genere el contrato para firmar.',
      'loanRequest.pendingApproval': 'Pendiente de Aprobación',
      
      // Loan Detail Page
      'loanDetail.title': 'Detalle del Préstamo',
      'loanDetail.loanAt': 'Préstamo al',
      'loanDetail.annual': 'anual',
      'loanDetail.interestGenerated': 'Intereses Generados',
      'loanDetail.estimatedTotalReturn': 'Retorno Total Estimado',
      'loanDetail.remainingDays': 'Días Restantes',
      'loanDetail.dailyInterest': 'Interés Diario',
      'loanDetail.loanTimeline': 'Línea de Tiempo del Préstamo',
      'loanDetail.completed': 'completado del plazo total',
      'loanDetail.accumulatedInterestProjection': 'Proyección de Intereses Acumulados',
      'loanDetail.months': 'Meses',
      'loanDetail.earlyCancellation': 'Cancelación Anticipada',
      'loanDetail.cancellationWarning': 'Si necesitas cancelar este préstamo antes del vencimiento, ten en cuenta que se aplicará una penalización del 2.5% sobre el tipo de interés.',
      'loanDetail.requestCancellation': 'Solicitar Cancelación Anticipada',
      'loanDetail.cancellationInProgress': 'Solicitud en Curso',
      'loanDetail.cancellationInProgressText': 'Tu solicitud de cancelación anticipada ha sido recibida y está siendo revisada por nuestro equipo. Te contactaremos pronto con la decisión.',
      'loanDetail.requestedOn': 'Solicitado',
      'loanDetail.cancellationRejected': 'Solicitud Rechazada',
      'loanDetail.cancellationRejectedText': 'Tu solicitud de cancelación anticipada ha sido rechazada.',
      'loanDetail.reason': 'Motivo',
      'loanDetail.contractInfo': 'Información del Contrato',
      'loanDetail.viewContract': 'Ver Contrato',
      'loanDetail.language': 'Idioma',
      
      // Admin Cancellations
      'admin.cancellations': 'Cancelaciones Anticipadas',
      'admin.noCancellationRequests': 'No hay solicitudes de cancelación pendientes',
      'admin.approveCalculation': 'Aprobar Cancelación',
      'admin.reject': 'Rechazar',
      'admin.currentInterest': 'Interés Actual',
      'admin.newInterestWithPenalty': 'Nuevo Interés (con Penalización)',
      'admin.lenderNotes': 'Notas del Prestamista',
      
      'common.locale': 'es-ES',
      
      // Referral Bonus
      'referral.title': 'Bonus Programa Referidos',
      'referral.subtitle': 'Ganas el 1% del capital de tus referidos activos',
      'referral.activeReferrals': 'Referidos Activos',
      'referral.totalReferredCapital': 'Capital Referido Total',
      'referral.annualBonusGross': 'Bonus Anual Bruto',
      'referral.bonusNetAfterTax': 'Bonus Neto (tras 19% ret.)',
      'referral.totalToReceive': 'TOTAL A RECIBIR AL VENCIMIENTO',
      'referral.ownInterests': 'Intereses de tus prestamos',
      'referral.bonusReferrals': 'Bonus Referidos (1%)',
      'referral.subtotalGross': 'Subtotal Bruto',
      'referral.irpfRetention': 'Retención IRPF (19%)',
      'referral.totalNetToReceive': 'TOTAL NETO A RECIBIR',
      'referral.viewReferralDetail': 'Ver detalle de referidos',
      'referral.bonus': 'Bonus',
      'referral.adminNote': 'Los bonos se pagarán junto con los intereses al vencimiento de cada prestamo. La retención del 19% se aplica sobre el total (intereses + bonus). Cada prestamista recibirá un certificado Modelo 123 con el detalle completo.',
      'referral.pendingBonuses': 'prestamista(s) con bonos pendientes',
      'referral.ownCapital': 'Capital Propio',
      'referral.ownInterestsGross': 'Intereses Brutos',
      'referral.referredCapitalLabel': 'Capital Referido',
      'referral.loanCount': 'prestamo(s)',
      'referral.bonusGross': 'Bonus Bruto',
      'referral.totalNetToPay': 'Total Neto a Pagar',
      'referral.totalGross': 'Bruto',
      'referral.retention19': 'Ret. 19%',
      'referral.fiscalNote': 'Este bonus se pagará junto con los intereses de tu préstamo al vencimiento. La retención del 19% se aplica sobre el total (intereses + bonus). Recibirás un certificado anual (Modelo 123) con el detalle completo para tu declaración de IRPF.',
      
      // Cancellations
      'cancellations.approvedTitle': 'Cancelaciones Aprobadas (Pendientes de Ejecución)',
      'cancellations.pendingExecution': 'Pendiente de Ejecución',
      'cancellations.executing': 'Ejecutando...',
      'cancellations.executeNow': 'Ejecutar Cancelación Ahora',
      'cancellations.confirmExecute': 'EJECUTAR cancelación del prestamo de {{name}}? Esto cerrará el prestamo y generará el anexo de liquidación.',
      'cancellations.executed': 'Cancelación ejecutada. Prestamo cerrado y anexo generado.',
      'cancellations.errorExecute': 'Error al ejecutar cancelación',
      'cancellations.confirmApprove': 'Aprobar la solicitud de cancelación de {{name}}? El prestamo continuará activo hasta que se ejecute.',
      'cancellations.approved': 'Solicitud aprobada. El prestamo continúa activo.',
      'cancellations.rejected': 'Cancelación rechazada.',
      'cancellations.errorReject': 'Error al rechazar cancelación',
      'cancellations.inProgress': 'Cancelación en Curso',
      'cancellations.approvedLabel': 'Cancelación Aprobada',
      'cancellations.rejectedLabel': 'Cancelación Rechazada',
      'cancellations.reason': 'Motivo',
      
      // Documents
      'documents.title': 'Documentos Asociados',
      'documents.uploaded': 'Documento subido correctamente',
      'documents.deleted': 'Documento eliminado',
      'documents.onlyPdfImages': 'Solo PDFs e imágenes permitidos',
      'documents.model600': 'Modelo 600',
      'documents.transfer': 'Justificante Transferencia',
      'documents.receipt': 'Justificante Recepción',
      'documents.other': 'Otros',
      'documents.document': 'Documento',
      'documents.noDocuments': 'No hay documentos asociados',
      'documents.confirmDelete': 'Eliminar este documento?',
      
      // Loan Requests  
      'loanRequests.title': 'Solicitudes de Prestamos',
      'loanRequests.rejectPrompt': 'Rechazar {{name}} ({{amount}}€)? Motivo (se enviará por email):',
      'loanRequests.requestNew': 'Solicitar Nuevo Prestamo',
      
      // Rate Tiers
      'rateTiers.title': 'Configuración de Baremos',
      'rateTiers.description': 'Cuando un prestamista solicita un nuevo prestamo, el sistema calculará automaticamente el tipo de interes según estos baremos basados en el importe solicitado.',
      'rateTiers.autoRates': 'Baremos de Intereses Automaticos',
      'rateTiers.interestRate': 'Tipo de Interés (%)',
      'rateTiers.minAmount': 'Importe Mínimo (€)',
      'rateTiers.maxAmount': 'Importe Máximo (€)',
      'rateTiers.leaveEmpty': 'Dejar vacío para infinito',
      'rateTiers.range': 'Rango',
      
      // Waitlist Admin
      'waitlistAdmin.invitationCode': 'Código de invitación',
      'waitlistAdmin.recommendedBy': 'Recomendado por',
      'waitlistAdmin.unknown': 'Desconocido',
      'waitlistAdmin.pending': 'Pendiente',
      'waitlistAdmin.approved': 'Aprobado',
      'waitlistAdmin.rejected': 'Rechazado',
      
      // Misc
      'misc.download': 'Descargar',
      'misc.sign': 'Firmar',
      'misc.active': 'Activo',
      'misc.pending': 'Pendiente',
      'misc.deleteConfirm': 'Debes escribir exactamente "ELIMINAR" para confirmar.',
      'misc.deleteLender': 'Eliminar prestamista',
      'misc.loanDeleted': 'Prestamo eliminado correctamente',
      'misc.loanAlreadyDeleted': 'Este prestamo ya había sido eliminado anteriormente.',
      'misc.invitationsMustBe': 'El número debe estar entre 1 y 10'
    }
  },
  ca: {
    translation: {
      'common.login': 'Iniciar Sessió',
      'common.logout': 'Tancar Sessió',
      'common.email': 'Correu Electrònic',
      'common.password': 'Contrasenya',
      'common.name': 'Nom',
      'common.surname': 'Cognoms',
      'common.save': 'Desar',
      'common.cancel': 'Cancel·lar',
      'common.loading': 'Carregant...',
      'common.error': 'Error',
      'common.success': 'Èxit',
      'common.search': 'Cercar',
      'common.filter': 'Filtrar',
      'common.download': 'Descarregar',
      'common.sign': 'Signar',
      'common.signHere': 'Signi aquí',
      'common.clear': 'Netejar',
      'common.submit': 'Enviar',
      'common.back': 'Tornar',
      'common.viewDetails': 'Veure Detalls',
      'dashboard.title': 'Panell de Prestamista',
      'dashboard.totalCapital': 'Capital Total Invertit',
      'loanRequest.pendingRequests': 'Sol·licituds Pendents',
      'loanRequest.rejectedRequests': 'Sol·licituds Rebutjades',
      'loanRequest.noPendingRequests': 'No hi ha sol·licituds pendents',
      'loanRequest.canRequestFromDashboard': 'Pots sol·licitar un nou préstec des del Dashboard',

      'dashboard.interestToday': 'Interessos Avui',
      'dashboard.interestMonth': 'Interessos Aquest Mes',
      'dashboard.estimatedReturn': 'Retorn Estimat Total',
      'dashboard.activeLoans': 'Préstecs Actius',
      'dashboard.pendingSignatures': 'Signatures Pendents',
      'dashboard.yourMoneyWorking': 'Els teus diners estan treballant per a tu',
      'dashboard.investMore': 'Vull invertir més',
      'dashboard.interestEvolution': 'Evolució d\'Interessos',
      'dashboard.simulator': 'Simulador d\'Inversió',
      'dashboard.simulatorDesc': 'Si inverteixes',
      'dashboard.wouldBe': 'el teu retorn seria',
      'dashboard.days': 'dies',
      'dashboard.daysRemaining': 'dies restants',
      'loans.title': 'Els Meus Préstecs',
      'loans.loanId': 'ID Préstec',
      'loans.capital': 'Capital',
      'loans.interestRate': 'Tipus d\'Interès',
      'loans.startDate': 'Data Inici',
      'loans.endDate': 'Data Venciment',
      'loans.status': 'Estat',
      'loans.interestGenerated': 'Interessos Generats',
      'loans.daysRemaining': 'Dies Restants',
      'loans.active': 'Actiu',
      'loans.pending_signature': 'Pendent de Signatura',
      'loans.matured': 'Vençut',
      'loans.cancelled': 'Cancel·lat',
      'contracts.title': 'Contractes',
      'contracts.pendingSignature': 'Tens un contracte pendent de firma!',
      'contracts.clickToSign': 'Fes clic aqui per anar a firmar el teu contracte',
      'contracts.signed': 'Signats',
      'contracts.contractId': 'ID Contracte',
      'contracts.loanDetails': 'Detalls del Préstec',
      'contracts.signContract': 'Signar Contracte',
      'contracts.downloadContract': 'Descarregar Contracte',
      'contracts.signatures': 'Signatures',
      'contracts.lender': 'Prestamista',
      'contracts.company': 'Empresa',
      'contracts.signedAt': 'Signat el',
      'contracts.ipAddress': 'Adreça IP',
      'admin.dashboard': 'Panell d\'Administració',
      'admin.lenders': 'Prestamistes',
      'admin.loans': 'Préstecs',
      'admin.createLender': 'Crear Prestamista',
      'admin.createLoan': 'Crear Préstec',
      'admin.generateContract': 'Generar Contracte',
      'admin.totalCapital': 'Capital Total Gestionat',
      'admin.activeLoans': 'Préstecs Actius',
      'contracts.noContracts': 'No hi ha contractes disponibles',
      'contracts.contractsWillAppear': 'Els contractes apareixeran quan es generin',

      'admin.totalLenders': 'Total Prestamistes',
      'profile.lender': 'Prestamista',
      'sidebar.logout': 'Tancar Sessió',

      'admin.newLoansMonth': 'Nous Préstecs (Mes)',
      'admin.interestAccrued': 'Interessos Acumulats',
      'admin.lenderName': 'Nom del Prestamista',
      'admin.lenderEmail': 'Email del Prestamista',
      'admin.documentType': 'Tipus de Document',
      'admin.documentNumber': 'Número de Document',
      'admin.address': 'Adreça',
      'admin.phone': 'Telèfon',
      
      // Additional translations in Catalan
      'profile.title': 'El Meu Perfil',
      'profile.personalInfo': 'Informació Personal',
      'profile.changePassword': 'Canviar Contrasenya',
      'profile.currentPassword': 'Contrasenya Actual',
      'profile.newPassword': 'Nova Contrasenya',
      'profile.confirmPassword': 'Confirmar Nova Contrasenya',
      'profile.minChars': 'Mínim 6 caràcters',
      'profile.passwordUpdated': 'Contrasenya actualitzada correctament',
      'profile.passwordsDontMatch': 'Les contrasenyes no coincideixen',
      'profile.userName': 'Nom',
      'profile.userEmail': 'Email',
      'profile.userType': 'Tipus d\'usuari',
      'profile.userLanguage': 'Idioma',
      'profile.administrator': 'Administrador',
      'profile.lender': 'Prestamista',
      
      'forgotPassword.title': 'Recuperar Contrasenya',

      // Complete Profile
      'completeProfile.welcome': 'Benvingut',
      'completeProfile.subtitle': 'Completa el teu perfil per començar a invertir',
      'completeProfile.infoText': 'Per complir amb la normativa legal, necessitem els teus dades personals i fiscals abans de poder processar la teva primera sol·licitud de préstec.',
      'completeProfile.fillRequired': 'Si us plau, completa tots els camps obligatoris (inclòs IBAN)',
      'completeProfile.saved': 'Perfil completat correctament',
      'completeProfile.ibanNote': 'Per rebre transferències dels interessos generats',
      'completeProfile.saveButton': 'Guardar i Continuar',
      'completeProfile.requiredFields': 'Camps obligatoris',

      'forgotPassword.description': 'Introdueix el teu email i t\'enviarem una contrasenya temporal.',
      'forgotPassword.link': 'Has oblidat la contrasenya?',
      'forgotPassword.success': 'Si l\'email existeix, rebràs instruccions.',
      'forgotPassword.error': 'Error al processar',
      
      'investment.requestTitle': 'Sol·licitar Nova Inversió',
      'investment.amount': 'Import a Invertir (€)',
      'investment.notes': 'Notes addicionals (opcional)',
      'investment.notesPlaceholder': 'Preferències de termini, condicions especials, etc.',
      'investment.emailNote': 'En enviar, rebrem la teva sol·licitud i ens posarem en contacte amb tu aviat.',
      'investment.sendRequest': 'Enviar Sol·licitud',
      'investment.sending': 'Enviant...',
      'investment.success': 'Sol·licitud enviada correctament. Ens posarem en contacte en breu.',
      
      'loanDetail.title': 'Detall del Préstec',
      'loanDetail.loanAt': 'Préstec al',
      'loanDetail.annual': 'anual',
      'loanDetail.interestGenerated': 'Interessos Generats',
      'loanDetail.estimatedReturn': 'Retorn Total Estimat',
      'loanDetail.daysRemaining': 'Dies Restants',
      'loanDetail.dailyInterest': 'Interès Diari',
      'loanDetail.timeline': 'Línia de Temps del Préstec',
      'loanDetail.completed': 'completat del termini total',
      'loanDetail.projection': 'Projecció d\'Interessos Acumulats',
      'loanDetail.contractInfo': 'Informació del Contracte',
      'loanDetail.viewContract': 'Veure Contracte',
      'loanDetail.earlyCancellation': 'Cancel·lació Anticipada',
      'loanDetail.cancellationWarning': 'Si necessites cancel·lar aquest préstec abans del venciment, tingues en compte que s\'aplicarà una penalització del 2.5% sobre el tipus d\'interès.',
      'loanDetail.requestCancellation': 'Sol·licitar Cancel·lació Anticipada',
      'loanDetail.cancellationConfirm': 'Sol·licitar cancel·lació anticipada?',
      'loanDetail.penalty': 'Penalització: El teu tipus d\'interès es reduirà de',
      'loanDetail.to': 'a',
      'loanDetail.requestReceived': 'Sol·licitud rebuda correctament. Ens posarem en contacte en breu.',
      
      'simulator.title': 'Simulador d\'Inversió',
      'simulator.ifYouInvest': 'Si inverteixes',
      'simulator.additional': 'addicionals',
      'simulator.estimatedReturn': 'Retorn estimat:',
      'simulator.increase': 'Augment de',
      'simulator.simulate': 'Simula quant guanyaries invertint:',
      'simulator.amount': 'Import',
      'simulator.interestRate': "Tipus d'interès",
      'simulator.earningsDay': 'GUANYS PER DIA',
      'simulator.earningsMonth': 'GUANYS PER MES',
      'simulator.earningsYear': 'GUANYS PER ANY',
      'simulator.dailyGrowth': 'El teu diner creix cada dia!',
      'simulator.monthlyIncome': 'Ingressos mensuals garantits',
      'simulator.totalYield': 'Rendiment total anual',
      'simulator.totalReturn': 'Retorn total a 12 mesos',
      
      'buttons.investMore': 'Vull Invertir Més',
      'buttons.viewAllLoans': 'Veure tots els préstecs',
      'buttons.createLender': 'Crear Prestamista',
      'buttons.createLoan': 'Crear Préstec',
      'buttons.editLoan': 'Editar',
      'buttons.generateES': 'Generar ES',
      'buttons.generateCA': 'Generar CA',
      'buttons.personalizeContract': 'Personalitzar Contracte',
      'buttons.exportCSV': 'Exportar CSV',
      'buttons.resetPassword': 'Reset',
      'buttons.edit': 'Editar',
      'buttons.save': 'Desar',
      'buttons.saveChanges': 'Desar Canvis',
      'buttons.saveDraft': 'Desar Esborrany',
      'buttons.generateAndSend': 'Generar Contracte i Enviar',
      'buttons.back': 'Tornar',
      
      'status.active': 'Actiu',
      'status.pending': 'Pendent',
      'status.matured': 'Vençut',
      'status.cancelled': 'Cancel·lat',
      'status.contractGenerated': 'Contracte generat',
      
      'messages.lenderCreated': 'Prestamista creat correctament',
      'messages.loanCreated': 'Préstec creat correctament',
      'messages.loanUpdated': 'Préstec actualitzat correctament',
      'messages.lenderUpdated': 'Prestamista actualitzat correctament',
      'messages.passwordReset': 'Contrasenya restablerta correctament',
      'messages.communicatePassword': 'Comunica aquesta contrasenya a l\'usuari.',
      'messages.csvExported': 'Informe CSV descarregat correctament',
      'messages.noDataToExport': 'No hi ha dades per exportar',
      'messages.contractGenerated': 'Contracte generat i emails enviats',
      'messages.signedSuccessfully': 'Contracte signat correctament',
      'messages.pleaseSign': 'Si us plau, signi al requadre',
      'messages.confirmDelete': 'Esteu segur?',
      'messages.error': 'Error',
      'messages.success': 'Èxit',
      
      'labels.name': 'Nom',
      'labels.surname': 'Cognoms',
      'labels.email': 'Email',
      'labels.docType': 'Tipus de Document',
      'labels.docNumber': 'Número de Document',
      'labels.address': 'Adreça Completa',
      'labels.phone': 'Telèfon',
      'labels.country': 'País',
      'labels.iban': 'IBAN (Opcional)',
      'labels.language': 'Idioma Preferit',
      'labels.lender': 'Prestamista',
      'labels.capital': 'Capital (€)',
      'labels.interestRate': 'Tipus d\'Interès (%)',
      'labels.duration': 'Duració (mesos)',
      'labels.startDate': 'Data d\'Inici',
      'labels.actions': 'Accions',
      'labels.fullName': 'Nom Complet',
      'labels.document': 'Document',
      
      'placeholders.searchLenders': 'Cercar per nom, cognoms o email...',
      'placeholders.selectLender': 'Seleccionar...',
      'placeholders.amount': '10000',
      'placeholders.address': 'C/ Méndez Núñez, 8, 1r 2a, 08003, Barcelona',
      'placeholders.phone': '+34 912 345 678',
      'placeholders.iban': 'ES91 2100 0418 4502 0005 1332',
      
      'titles.editLender': 'Editar Prestamista',
      'titles.createLender': 'Crear Nou Prestamista',
      'titles.editLoan': 'Editar Préstec',
      'titles.createLoan': 'Crear Nou Préstec',
      'titles.loanTerms': 'Termes del Préstec (Editables)',
      'titles.summary': 'Resum',
      'titles.welcome': 'Hola',
      'titles.dashboardSubtitle': 'Aquí està el resum de la teva gestió',
      'titles.activeLoans': 'Préstecs Actius',
      'titles.statusDistribution': 'Distribució per Estat',
      'titles.quickStats': 'Estadístiques Clau',
      'titles.recentActivity': 'Activitat Recent',
      
      'stats.avgCapital': 'Capital Mitjà/Préstec',
      'stats.signRate': 'Taxa de Signatura',
      'stats.newThisMonth': 'Nous Aquest Mes',
      'stats.totalManaged': 'Total en gestió activa',
      'stats.generatedToday': 'Generats fins avui',
      'stats.currentlyActive': 'En curs actualment',
      'stats.registeredInvestors': 'Inversors registrats',
      'stats.daysRemaining': 'dies restants',
      'stats.at': 'al',
      
      // Error messages and alerts
      'errors.unknown': 'Error desconegut',
      'errors.loading': 'Error al carregar',
      'errors.downloading': 'Error al descarregar',
      'errors.saving': 'Error al desar',
      'errors.creating': 'Error al crear',
      
      // Status labels
      'status.creating': 'Creant...',
      'status.saving': 'Desant...',
      'status.loading': 'Carregant...',
      'status.all': 'Tots',
      
      // Modal titles
      'modal.createLender': '+ Crear Nou Prestamista',
      'modal.editLender': '✏️ Editar Prestamista',
      'modal.createLoan': '+ Crear Nou Préstec',
      'modal.editLoan': '✏️ Editar Préstec',
      
      // Button labels with icons
      'buttons.createLenderButton': '✓ Crear Prestamista',
      'buttons.createLoanButton': '✓ Crear',
      
      // Date formats
      'date.signedOn': 'Signat el',
      'date.ip': 'IP',
      
      // Contract editing
      'contract.editTitle': 'Editar Contracte',
      'contract.loanTerms': 'Termes del Préstec (Editables)',
      'contract.generating': 'Generant...',
      'contract.generateFinal': 'Generar Contracte Final',
      
      // Loan Requests
      'loanRequest.suggestedRate': "Tipus d'interès",
      'loanRequest.annual': 'anual',
      'loanRequest.requestDate': 'DATA SOL·LICITUD',
      'loanRequest.notes': 'NOTES',
      'loanRequest.statusTitle': "Estat de la sol·licitud",
      'loanRequest.statusMessage': "La teva sol·licitud de {amount}€ està sent revisada per l'equip de Vivendius. Rebràs una notificació per email quan sigui aprovada i es generi el contracte per signar.",
      'loanRequest.pendingApproval': "Pendent d'Aprovació",
      
      
      // Waitlist & Invitations
      'waitlist.title': 'Sol·licita Accés a Vivendius',
      'waitlist.subtitle': 'Uneix-te al club d\'inversors exclusiu',
      'waitlist.nombre': 'Nom Complet',
      'waitlist.email': 'Email',
      'waitlist.telefono': 'Telèfon',
      'waitlist.joinWaitlist': 'Unir-me a la Llista d\'Espera',
      'waitlist.successTitle': 'Sol·licitud Enviada!',
      'waitlist.successMessage': 'Revisarem la teva sol·licitud i ens posarem en contacte aviat.',
      'waitlist.backToHome': 'Tornar a l\'inici',

      'waitlist.capitalDisponible': 'Capital Disponible',
      'waitlist.tipoInversion': 'Tipus d\'Inversió',
      'waitlist.shortTerm': 'Curt termini (12 mesos)',
      'waitlist.mediumTerm': 'Mitjà termini (24 mesos)',
      'waitlist.longTerm': 'Llarg termini (36 mesos)',
      'waitlist.minAmount': 'Mínim: {{amount}}€',
      'waitlist.invitationCode': 'Codi d\'Invitació',
      'waitlist.notas': 'Notes addicionals (opcional)',
      'waitlist.submit': 'Enviar Sol·licitud',
      'waitlist.success': 'Sol·licitud enviada correctament! Ens posarem en contacte aviat.',
      'waitlist.exclusiveMessage': 'Inversions exclusives en propietats tangibles a Barcelona. Comprem, rehabilitem i venem amb totes les garanties.',
      'waitlist.missionMessage': 'Amb la teva col·laboració ens estàs ajudant a créixer i oferir vivendes a preus assequibles per a famílies i parelles joves que busquen llibertat, qualitat i preu assequible sense intermediaris.',
      'waitlist.exclusiveClub': 'Club Exclusiu per Invitació',
      'waitlist.limitedAccess': 'Accés limitat a inversors de confiança',
      
      'invitations.title': 'Les Meves Invitacions',
      'invitations.available': 'Invitacions Disponibles',
      'invitations.used': 'Invitacions Utilitzades',
      'invitations.generate': 'Generar Codi d\'Invitació',
      'waitlist.tagline': 'Investments Made Easy',
      
      // Invitations (CA)
      'invitations.myInvitations': 'Les Meves Invitacions',
      'invitations.inviteTrusted': 'Convida persones de confiança al club Vivendius',
      'invitations.available': 'Disponibles',
      'invitations.generateNewCode': 'Generar Nou Codi d\'Invitació',
      'invitations.codeOnceUse': 'Cada codi es pot utilitzar una vegada. Comparteix-lo només amb persones de confiança.',
      'invitations.generateCode': '+ Generar Codi',
      'invitations.generating': 'Generant...',
      'invitations.codeGenerated': 'Codi generat!',
      'invitations.copy': 'Copiar',
      'invitations.noInvitationsLeft': 'Has utilitzat totes les invitacions',
      'invitations.myCodes': 'Els Meus Codis',
      'invitations.noCodesYet': 'Encara no has generat cap codi',
      'invitations.usedBy': 'Utilitzat per',
      'invitations.active': 'Actiu',
      'invitations.used': 'Utilitzat',
      
      // Sidebar & Navigation
      'sidebar.projects': 'Projectes',
      'sidebar.waitlist': 'Llista d\'Espera',
      'sidebar.loanRequests': 'Sol·licituds Préstecs',
      'sidebar.pendingCancellations': 'Cancel·lacions Pendents',
      'sidebar.approvedCancellations': 'Cancel·lacions Aprovades',
      'sidebar.rateTiers': 'Barems',
      'sidebar.profile': 'Perfil',
      'sidebar.dashboard': 'Dashboard',

      'waitlist.waitingList': 'Llista d\'Espera',
      'waitlist.privateClub': 'Club Privat d\'Inversors Immobiliaris',
      'waitlist.onlyInvitation': 'NOMÉS PER INVITACIÓ',
      'waitlist.restrictedAccess': 'Accés Restringit',
      'waitlist.privateExclusiveClub': 'Club exclusiu privat. Només es pot accedir amb invitació',

      'waitlist.guaranteedFixed': 'Fix Garantit',
      'waitlist.barcelona': 'Barcelona',
      'waitlist.risks': 'Riscos',

      'invitations.yourCode': 'El Teu Codi',
      'invitations.shareCode': 'Comparteix aquest codi amb persones de confiança',
      'waitlist.codeRequired': 'Codi Requerit',
      'waitlist.alreadyHaveAccount': 'Ja tens compte? Inicia sessió',

      'invitations.noInvitations': 'Has utilitzat totes les teves invitacions',
      'invitations.usedBy': 'Utilitzat per',
      'invitations.status': 'Estat',
      
      'admin.waitlist': 'Llista d\'Espera',
      'admin.waitlistPending': 'Pendents d\'Aprovació',
      'admin.approveEntry': 'Aprovar',
      'admin.rejectEntry': 'Rebutjar',
      'admin.waitlistName': 'Nom',
      'admin.waitlistCapital': 'Capital Disponible',
      'admin.waitlistType': 'Tipus Inversió',
      'admin.waitlistReferredBy': 'Referit per',
      
      // Loan Detail Page
      'loanDetail.title': 'Detall del Préstec',
      'loanDetail.loanAt': 'Préstec al',
      'loanDetail.annual': 'anual',
      'loanDetail.interestGenerated': 'Interessos Generats',
      'loanDetail.estimatedTotalReturn': 'Retorn Total Estimat',
      'loanDetail.remainingDays': 'Dies Restants',
      'loanDetail.dailyInterest': 'Interès Diari',
      'loanDetail.loanTimeline': 'Línia de Temps del Préstec',
      'loanDetail.completed': 'completat del termini total',
      'loanDetail.accumulatedInterestProjection': 'Projecció d\'Interessos Acumulats',
      'loanDetail.months': 'Mesos',
      'loanDetail.earlyCancellation': 'Cancel·lació Anticipada',
      'loanDetail.cancellationWarning': 'Si necessites cancel·lar aquest préstec abans del venciment, tingues en compte que s\'aplicarà una penalització del 2.5% sobre el tipus d\'interès.',
      'loanDetail.requestCancellation': 'Sol·licitar Cancel·lació Anticipada',
      'loanDetail.cancellationInProgress': 'Sol·licitud en Curs',
      'loanDetail.cancellationInProgressText': 'La teva sol·licitud de cancel·lació anticipada ha estat rebuda i està sent revisada pel nostre equip. Et contactarem aviat amb la decisió.',
      'loanDetail.requestedOn': 'Sol·licitat',
      'loanDetail.cancellationRejected': 'Sol·licitud Rebutjada',
      'loanDetail.cancellationRejectedText': 'La teva sol·licitud de cancel·lació anticipada ha estat rebutjada.',
      'loanDetail.reason': 'Motiu',
      'loanDetail.contractInfo': 'Informació del Contracte',
      'loanDetail.viewContract': 'Veure Contracte',
      'loanDetail.language': 'Idioma',
      
      // Admin Cancellations
      'admin.cancellations': 'Cancel·lacions Anticipades',
      'admin.noCancellationRequests': 'No hi ha sol·licituds de cancel·lació pendents',
      'admin.approveCalculation': 'Aprovar Cancel·lació',
      'admin.reject': 'Rebutjar',
      'admin.currentInterest': 'Interès Actual',
      'admin.newInterestWithPenalty': 'Nou Interès (amb Penalització)',
      'admin.lenderNotes': 'Notes del Prestamista',
      
      'common.locale': 'ca-ES',
      
      // Referral Bonus
      'referral.title': 'Bonus Programa Referits',
      'referral.subtitle': 'Guanyes el 1% del capital dels teus referits actius',
      'referral.activeReferrals': 'Referits Actius',
      'referral.totalReferredCapital': 'Capital Referit Total',
      'referral.annualBonusGross': 'Bonus Anual Brut',
      'referral.bonusNetAfterTax': 'Bonus Net (després 19% ret.)',
      'referral.totalToReceive': 'TOTAL A REBRE AL VENCIMENT',
      'referral.ownInterests': 'Interessos dels teus préstecs',
      'referral.bonusReferrals': 'Bonus Referits (1%)',
      'referral.subtotalGross': 'Subtotal Brut',
      'referral.irpfRetention': 'Retenció IRPF (19%)',
      'referral.totalNetToReceive': 'TOTAL NET A REBRE',
      'referral.viewReferralDetail': 'Veure detall dels referits',
      'referral.bonus': 'Bonus',
      'referral.adminNote': 'Els bonos es pagaran juntament amb els interessos al venciment de cada préstec. La retenció del 19% s\'aplica sobre el total (interessos + bonus). Cada prestamista rebrà un certificat Model 123 amb el detall complet.',
      'referral.pendingBonuses': 'prestamista(es) amb bonus pendents',
      'referral.ownCapital': 'Capital Propi',
      'referral.ownInterestsGross': 'Interessos Bruts',
      'referral.referredCapitalLabel': 'Capital Referit',
      'referral.loanCount': 'préstec(s)',
      'referral.bonusGross': 'Bonus Brut',
      'referral.totalNetToPay': 'Total Net a Pagar',
      'referral.totalGross': 'Brut',
      'referral.retention19': 'Ret. 19%',
      'referral.fiscalNote': 'Aquest bonus es pagarà juntament amb els interessos del teu préstec al venciment. La retenció del 19% s\'aplica sobre el total (interessos + bonus). Rebràs un certificat anual (Model 123) amb el detall complet per a la teva declaració d\'IRPF.',
      
      // Cancellations
      'cancellations.approvedTitle': 'Cancel·lacions Aprovades (Pendents d\'Execució)',
      'cancellations.pendingExecution': 'Pendent d\'Execució',
      'cancellations.executing': 'Executant...',
      'cancellations.executeNow': 'Executar Cancel·lació Ara',
      'cancellations.confirmExecute': 'EXECUTAR cancel·lació del préstec de {{name}}? Això tancarà el préstec i generarà l\'anexo de liquidació.',
      'cancellations.executed': 'Cancel·lació executada. Préstec tancat i anexo generat.',
      'cancellations.errorExecute': 'Error en executar cancel·lació',
      'cancellations.confirmApprove': 'Aprovar la sol·licitud de cancel·lació de {{name}}? El préstec continuarà actiu fins que s\'executi.',
      'cancellations.approved': 'Sol·licitud aprovada. El préstec continua actiu.',
      'cancellations.rejected': 'Cancel·lació rebutjada.',
      'cancellations.errorReject': 'Error en rebutjar cancel·lació',
      'cancellations.inProgress': 'Cancel·lació en Curs',
      'cancellations.approvedLabel': 'Cancel·lació Aprovada',
      'cancellations.rejectedLabel': 'Cancel·lació Rebutjada',
      'cancellations.reason': 'Motiu',
      
      // Documents
      'documents.title': 'Documents Associats',
      'documents.uploaded': 'Document pujat correctament',
      'documents.deleted': 'Document eliminat',
      'documents.onlyPdfImages': 'Només PDFs i imatges permesos',
      'documents.model600': 'Model 600',
      'documents.transfer': 'Justificant Transferència',
      'documents.receipt': 'Justificant Recepció',
      'documents.other': 'Altres',
      'documents.document': 'Document',
      'documents.noDocuments': 'No hi ha documents associats',
      'documents.confirmDelete': 'Eliminar aquest document?',
      
      // Loan Requests
      'loanRequests.title': 'Sol·licituds de Préstecs',
      'loanRequests.rejectPrompt': 'Rebutjar {{name}} ({{amount}}€)? Motiu (s\'enviarà per email):',
      'loanRequests.requestNew': 'Sol·licitar Nou Préstec',
      
      // Rate Tiers
      'rateTiers.title': 'Configuració de Barems',
      'rateTiers.description': 'Quan un prestamista sol·licita un nou préstec, el sistema calcularà automàticament el tipus d\'interès segons aquests barems basats en l\'import sol·licitat.',
      'rateTiers.autoRates': 'Barems d\'Interessos Automàtics',
      'rateTiers.interestRate': 'Tipus d\'Interès (%)',
      'rateTiers.minAmount': 'Import Mínim (€)',
      'rateTiers.maxAmount': 'Import Màxim (€)',
      'rateTiers.leaveEmpty': 'Deixar buit per infinit',
      'rateTiers.range': 'Rang',
      
      // Waitlist Admin
      'waitlistAdmin.invitationCode': 'Codi d\'invitació',
      'waitlistAdmin.recommendedBy': 'Recomanat per',
      'waitlistAdmin.unknown': 'Desconegut',
      'waitlistAdmin.pending': 'Pendent',
      'waitlistAdmin.approved': 'Aprovada',
      'waitlistAdmin.rejected': 'Rebutjada',
      
      // Misc
      'misc.download': 'Descarregar',
      'misc.sign': 'Signar',
      'misc.active': 'Actiu',
      'misc.pending': 'Pendent',
      'misc.deleteConfirm': 'Has d\'escriure exactament "ELIMINAR" per confirmar.',
      'misc.deleteLender': 'Eliminar prestamista',
      'misc.loanDeleted': 'Préstec eliminat correctament',
      'misc.loanAlreadyDeleted': 'Aquest préstec ja havia estat eliminat anteriorment.',
      'misc.invitationsMustBe': 'El número ha d\'estar entre 1 i 10'
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: localStorage.getItem('language') || 'ca', // Default: Català
    fallbackLng: 'ca',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;